import { AppShell } from '@/context';
import type { NotificationArgsProps } from 'antd';

type NotificationType = 'success' | 'error' | 'info' | 'warning' | 'destroy' | 'open';
interface NotificationPropsType {
    type?: NotificationType;
    config?: NotificationArgsProps | string;
    key?: string;
}
type NotificationDestroyPropsType = (
    NotificationPropsType & {
        type: 'destroy';
        key?: string;
    }
);
type NotificationCommonPropsType = (
    NotificationPropsType & {
        type: Exclude<NotificationType, 'destroy'>;
        config: NotificationArgsProps | string;
    }
)
// eslint-disable-next-line no-unused-vars
type NotificationFuncType =  (config: NotificationArgsProps | string) => void;

const useNotification = () => {
    const { notification: antdNotification } = AppShell.useApp();
    // eslint-disable-next-line no-unused-vars
    function notificationMain(props: NotificationDestroyPropsType): void;
    // eslint-disable-next-line no-unused-vars
    function notificationMain(props: NotificationCommonPropsType): void;
    function notificationMain(props: NotificationPropsType): void {
        const {
            type = 'info',
            config,
            key
        } = props;


        const configObj = () => {
            if (typeof config === 'string') {
                return {
                    message: config
                };
            }
            return config || { message: '' };
        };

        if (type === 'destroy') {
            antdNotification.destroy(key);
        } else {
            antdNotification[type](configObj());
        }
    };

    type CompoundedComponent = typeof notificationMain & {
        success: NotificationFuncType;
        error: NotificationFuncType;
        info: NotificationFuncType;
        warning: NotificationFuncType;
        // eslint-disable-next-line no-unused-vars
        open: (config: NotificationArgsProps) => void;
        // eslint-disable-next-line no-unused-vars
        destroy: (key?: string) => void;
    };

    const notification: CompoundedComponent = (props) => notificationMain(props);

    notification.success = (config) => {
        return notificationMain({ type: 'success', config });
    };

    notification.error = (config) => {
        return notificationMain({ type: 'error', config });
    };

    notification.info = (config) => {
        return notificationMain({ type: 'info', config });
    };

    notification.warning = (config) => {
        return notificationMain({ type: 'warning', config });
    };

    notification.open = (config) => {
        return notificationMain({ type: 'open', config });
    };

    notification.destroy = (key) => {
        return notificationMain({ type: 'destroy', key });
    };

    return notification;
};

export default useNotification;
